module.exports = __webpack_public_path__ + "img/Close.638b2e09.svg";